import times from 'lodash/times';

export const generateOptions = (count, startFrom = 1) => times(count).map(item => ({
  name: startFrom + item,
  value: startFrom + item,
}));
